/** True when a CRM-sourced text value has something worth rendering (blank strings count as missing). */
export const hasDisplayValue = (value: string | null | undefined): boolean =>
  typeof value === 'string' && value.trim().length > 0;
